export interface LatLng {
    lat: number;
    lng: number;
}

export interface UserLocation {
    latitude: number;
    longitude: number;
    formatted_address: string;
    heading_text?: string
}

export interface CompanyName {
    id: number;
    name: string;
}

export class HeaderState {
    isCartPage = false;
    isMenuPage = false;
    isOrdersPage = false;
    isMainPage = false;
    isBulkOrderPage = false;
    isBrandingPage = false;
    isAccountPage = false
    isOffersPage = false;
    isCreditsPage = false;
    showEditButton = true;
    showCartCount = 0;
    currentUrl = '';
    text = '';
    showCartIcon = false;
    showSearchBox = false;
}

export class BrandInfo {
    1 = 'BOX8';
    13 = 'MOJOPIZZA';
}
